
const digest = '948e189863e577238e119e7376cce35b35ca58b597f4a4886d9323f8421dcfe5';
const classes = {"wrapper":"_wrapper_c7wo0_1"};
const css = `._wrapper_c7wo0_1 {
  display: flex;
  flex-direction: column;
  gap: 20px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  